module.exports = __webpack_public_path__ + "media/images/admin/icons/sunset-56dee25c133f98abf50458f9e6eff282.svg";